import { z } from "zod";

/** Represents the enum public.template_status */
type TemplateStatus = "draft" | "published";

export default TemplateStatus;

/** Zod schema for template_status */
export const templateStatus = z.enum(["draft", "published"]);
